var React = require('react');

function IconCommentsSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M255.7 642.9h544.7V253.8H920c5.5 0 10 4.5 10 10v664.4L774.4 772.6l-508.8-6.3c-5.5-.1-9.9-4.5-9.9-10V642.9zm312.2-280.6c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3 45.3 20.3 45.3 45.3c-.1 25-20.3 45.3-45.3 45.3zM100 108.2v612.5l155.6-155.6h456.9c5.5 0 10-4.5 10-10V108.2c0-5.5-4.5-10-10-10H110c-5.5 0-10 4.5-10 10zm317.9 254.1c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3 45.3 20.3 45.3 45.3c0 25-20.3 45.3-45.3 45.3zm-155.5 0c-25 0-45.3-20.3-45.3-45.3s20.3-45.3 45.3-45.3 45.3 20.3 45.3 45.3c-.1 25-20.3 45.3-45.3 45.3z"}));
}

IconCommentsSolid.displayName = "IconCommentsSolid";

IconCommentsSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconCommentsSolid;

IconCommentsSolid.default = IconCommentsSolid;
